import { 
    LOGGEDIN_USER_INFO,
    REMOVE_USER_INFO
} from "constants/homeConstants";

const initialState = {
    loading: false,
}

function homeReducer(state = initialState, action) {
    switch (action.type) {
        case LOGGEDIN_USER_INFO:
            return { ...state, userInfo: action.payload };
        case REMOVE_USER_INFO:
            return { ...state, userInfo: '' };
        default: return state;
    }
}

export {
    homeReducer
}